import React from "react";

const ServiceKeyFeaturesSection = ({ title, subtitle, characteristicsList, textColor = "black" }) => (
	<section className={`flex flex-col gap-14 ${textColor === "white" ? "text-black" : "text-white"}`}>
		<div className={`flex flex-col gap-1 justify-start w-full`}>
			<h4 className={`text-lg text-ipxon-magenta `}>{title}</h4>
			<h3 className="text-2xl md:text-3xl font-bold">{subtitle}</h3>
		</div>
		<ul className="flex flex-col md:flex-row flex-wrap w-full gap-y-10 md:gap-y-20">
			{characteristicsList.map((characteristic, index) => (
				<li className="flex flex-col gap-4 h-full w-full md:w-1/2 2xl:w-1/3" key={index}>
					<div className="flex gap-3 items-center">
						<h4 className="font-bold uppercase text-base">{characteristic.title}</h4>
					</div>
					<p className="md:w-4/5 text-base text-ipxon-medium-dark-gray">{characteristic.text}</p>
				</li>
			))}
		</ul>
	</section>
);

export default ServiceKeyFeaturesSection;
